export default "__VITE_ASSET__DDQ7Vbt5__"